import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=115f17f4&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115f17f4')) {
      api.createRecord('115f17f4', component.options)
    } else {
      api.reload('115f17f4', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=115f17f4&", function () {
      api.rerender('115f17f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Authentication/Login/ForgotPassword.vue"
export default component.exports